module.exports = __webpack_public_path__ + "img/20m7.c71a257c.jpg";